import queryString from 'query-string'
import { useSearchParams as useReactRouterSearchParams } from 'react-router-dom'

export const useSearchParams = () => {
  const [searchParams, setSearchParams] = useReactRouterSearchParams()
  return [queryString.parse(searchParams.toString()), setSearchParams]
}
